import { KioskAdSetFragment, KioskAdSetPartialFragment } from '@occc/graphql';

import { AdSetPublishValidationErrors } from '../components/ad-set-publish-dialog.component';

/**
 * Validates a full KioskAdSetFragment for publishing.
 * This performs complete validation including schedule validation.
 */
export const validateAdSetForPublish = (
  adSet: KioskAdSetFragment,
): AdSetPublishValidationErrors => {
  const hasAsset = Boolean(adSet.asset?.id);
  const hasOffer = Boolean(adSet.offerId);
  const hasKiosks = Boolean(adSet.kiosks && adSet.kiosks.length > 0);

  const hasSchedule = Boolean(
    adSet.schedules &&
      adSet.schedules.length > 0 &&
      adSet.schedules.some(
        (schedule) =>
          schedule.days && schedule.days.length > 0 && schedule.startTime && schedule.endTime,
      ),
  );

  return {
    hasAsset,
    hasOffer,
    hasKiosks,
    hasSchedule,
  };
};

/**
 * Validates a partial KioskAdSetPartialFragment for publishing.
 * Note: Schedule validation cannot be performed on partial data,
 * so hasSchedule will be null (unknown).
 */
export const validatePartialAdSetForPublish = (
  adSet: KioskAdSetPartialFragment,
): AdSetPublishValidationErrors => {
  const hasAsset = Boolean(adSet.asset?.imageSet?.square);
  const hasOffer = Boolean(adSet.offerId);
  const hasKiosks = Boolean(adSet.kioskIds && adSet.kioskIds.length > 0);

  return {
    hasAsset,
    hasOffer,
    hasKiosks,
    hasSchedule: null,
  };
};

export const isAdSetValidForPublish = (validationResult: AdSetPublishValidationErrors): boolean => {
  return (
    validationResult.hasAsset &&
    validationResult.hasOffer &&
    validationResult.hasKiosks &&
    validationResult.hasSchedule === true
  );
};
